module.exports = __webpack_public_path__ + "img/25_43.3f9c5a44.png";